import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Ancien éditeur de droits par champ, embarqué comme onglet de la fiche bien.
 * Remplacé par `/v2/admin/droits-champs` (DroitsChampsPage) qui respecte le
 * mode fictif et ne fait aucune écriture non demandée.
 *
 * Ce composant écrivait directement dans `field_permissions` — y compris un
 * auto-bootstrap silencieux au montage et un bouton "Enregistrer" écrivant
 * une matrice complète, sans aucun verrou de mode fictif (audit sécurité
 * 2026-09-10). Plutôt que de patcher ces écritures, le composant est vidé de
 * tout appel Supabase : conserver un seul éditeur de droits, celui qui a
 * déjà le bon comportement.
 */
export function BienFieldPermissions() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/v2/admin/droits-champs", { replace: true });
  }, [navigate]);

  return (
    <div className="flex items-center justify-center py-20 text-text-muted gap-2">
      <Loader2 size={18} className="animate-spin" />
      <span className="text-sm">{t("biens.permissions.loading")}</span>
    </div>
  );
}
